window.addEventListener('load', () => {
    

    const steps = document.querySelectorAll('.ewiko-implementation .step');

    const modal = document.querySelector('.ewiko-implementation .modal-wrapper')

    steps.forEach((element: Element) => {
        element.addEventListener('click', () => {
            modal.classList.add('show');
        });
    });
})